/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbSyncLogBatchResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbSyncLogBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbSyncLogBatchResponse>): ServiceNowCmdbSyncLogBatchResponse {
        let obj = Object.assign(new ServiceNowCmdbSyncLogBatchResponse(), model);
        ServiceNowCmdbSyncLogBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbSyncLogBatchResponse>): ServiceNowCmdbSyncLogBatchResponse {
        if (!model) return null;
        return ServiceNowCmdbSyncLogBatchResponse.newInstance(<ServiceNowCmdbSyncLogBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbSyncLogBatchResponse) {
        if (!obj) return;

        models.ServiceNowCmdbSyncLogBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbSyncLogBatchResponse): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbSyncLogBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.ServiceNowCmdbSyncLog.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.ServiceNowCmdbSyncLog; };

}
